/** @jsx jsx */
import { jsx, Box, Image as ThemeUIImage, AspectImage, Text } from 'theme-ui';

const Image = ({
  image,
  alt,
  aspect,
  aspectWidth,
  aspectHeight,
  showCaption,
  captionOverride,
  roundedCorners,
}) => {
  return (
    <Box as="figure">
      {aspect ? (
        <AspectImage
          src={image}
          alt={alt}
          ratio={aspectWidth / aspectHeight}
          sx={{
            display: 'block',
            verticalAlign: 'top',
          }}
        />
      ) : (
        <ThemeUIImage
          src={image}
          alt={alt}
          sx={{
            display: 'block',
            verticalAlign: 'top',
            margin: '0 auto',
            borderRadius: (roundedCorners ? '20px' : '0'),
            width: '100%'
          }}
        />
      )}
      {showCaption && (
        <Text as="figcaption" variant="figcaption">
          {captionOverride || alt}
        </Text>
      )}
    </Box>
  );
};

export default Image;
